import { Pipe, PipeTransform } from '@angular/core';
import { TranslateValuePipe } from './translate-value.pipe';

@Pipe({
  name: 'splitAndTranslate',
  standalone: true,
})
export class SplitAndTranslatePipe implements PipeTransform {
  constructor(private readonly translateValuePipe: TranslateValuePipe) {}
  transform(value: string, separator: string, onlyLast: boolean = false): string {
    let splits = value ? value.split(separator) : [];

    if (onlyLast) {
      const last = splits.pop();
      splits = [splits.join(separator), last ?? ''];
    }

    const result = splits.map((word: string) => {
      return this.translateValuePipe.transform(word);
    });

    return result.join(separator);
  }
}
